module.exports = __webpack_public_path__ + "static/media/ic_ascensor_seleccionado.6381f110.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/services/ic_ascensor_seleccionado.webp
// module id = 181
// module chunks = 1